import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {PermissionList} from "../models/permissionList";
import {PermissionService} from "../services/permission.service";

@Injectable()
export class PermissionsResolve implements Resolve<PermissionList> {
    constructor(private permissionService: PermissionService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<PermissionList> {
        return this.permissionService.getAll();
    }
}
